import styled from 'styled-components'

export const LeftSideBarWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  height: 100%;
  min-height: 0;
  background: var(--ds-white, #ffffff);
  border-right: none;
  z-index: 10;

  [data-theme='dark'] & {
    background: var(--ds-blue-900, #050c1f);
  }

  /* Collapsed drawer content spans 12px–52px so it lines up with the DS Header logo tile (12px header padding + 40px logo). */
  & .ds-drawer {
    --ds-drawer-collapsed-width: 64px;
  }

  & .ds-drawer.ds-drawer--collapsed {
    padding: 0 8px;
  }

  /* DS icons ship with a fixed #002A69 fill; recolor it to the Drawer's icon color. Remove once the DS Drawer does this itself. */
  & .ds-drawer__item-icon [fill='#002A69'],
  & .ds-drawer__item-icon [fill='#002a69'] {
    fill: currentColor;
  }

  & .ds-drawer__item-icon [stroke='#002A69'],
  & .ds-drawer__item-icon [stroke='#002a69'] {
    stroke: currentColor;
  }
`
